import React from 'react';
import { Container, Row, Col, Card, CardBody, CardTitle, CardText, ListGroup, ListGroupItem } from 'reactstrap';

const DataPolicies = () => {
    return (
        <div>

 <Container className="vulnerability-disclosure">
            <Card className="mb-4">
                <CardBody>
                    <CardTitle tag="h2">OurOffice Vulnerability Disclosure Program (VDP)</CardTitle>
                    <CardText>
                        At OurOffice, the security and privacy of our users are top priorities. We recognize the important role 
                        that the security community plays in keeping our services safe and encourage responsible reporting of 
                        any vulnerabilities you may discover.
                    </CardText>
                </CardBody>
            </Card>

            <Card className="mb-4">
                <CardBody>
                    <CardTitle tag="h3">Scope</CardTitle>
                    <CardText>
                        This VDP applies to vulnerabilities discovered in the following:
                    </CardText>
                    <ListGroup>
                        <ListGroupItem>OurOffice.io and associated web applications</ListGroupItem>
                        <ListGroupItem>OurOffice mobile apps</ListGroupItem>
                        <ListGroupItem>APIs and backend services directly related to OurOffice</ListGroupItem>
                    </ListGroup>
                    <CardText className="mt-3">
                        Please note that vulnerabilities in third-party services and applications not controlled by OurOffice 
                        (e.g., third-party authentication systems or external APIs) are considered out of scope for this program.
                    </CardText>
                </CardBody>
            </Card>

            <Card className="mb-4">
                <CardBody>
                    <CardTitle tag="h3">Out of Scope</CardTitle>
                    <ListGroup>
                        <ListGroupItem>Social engineering attacks, including phishing</ListGroupItem>
                        <ListGroupItem>Denial of Service (DoS) attacks</ListGroupItem>
                        <ListGroupItem>Physical testing or hacking of hardware devices</ListGroupItem>
                        <ListGroupItem>Vulnerabilities in third-party apps or services not controlled by OurOffice</ListGroupItem>
                    </ListGroup>
                </CardBody>
            </Card>

            <Card className="mb-4">
                <CardBody>
                    <CardTitle tag="h3">Reporting a Vulnerability</CardTitle>
                    <CardText>
                        If you believe you have discovered a security vulnerability in any of our systems, we would like to 
                        know about it so we can take steps to address the issue as quickly as possible. Please report any 
                        potential security issues by emailing <a href="mailto:security@ouroffice.io">security@ouroffice.io</a> 
                        with the following details:
                    </CardText>
                    <ListGroup>
                        <ListGroupItem>A detailed description of the vulnerability.</ListGroupItem>
                        <ListGroupItem>Steps to reproduce the issue, including any relevant screenshots or logs.</ListGroupItem>
                        <ListGroupItem>Your contact information for follow-up (optional).</ListGroupItem>
                    </ListGroup>
                    <CardText className="mt-3">
                        We request that you do not publicly disclose the issue until we have had a reasonable amount of time 
                        to investigate and address it.
                    </CardText>
                </CardBody>
            </Card>

            <Card>
                <CardBody>
                    <CardTitle tag="h3">Our Commitment</CardTitle>
                    <CardText>
                        We will acknowledge receipt of your vulnerability report within 3 business days.
                    </CardText>
                    <CardText>
                        We will provide updates on our investigation within 10 business days.
                    </CardText>
                    <CardText>
                        We will work with you to understand the scope of the vulnerability and to fully remediate it.
                    </CardText>
                </CardBody>
            </Card>
        </Container>


        <Container className="data-storage-policy">
            <Card className="mb-4">
                <CardBody>
                    <CardTitle tag="h2">OurOffice Data Storage, Removal, Retention</CardTitle>
                </CardBody>
            </Card>

            <Card className="mb-4">
                <CardBody>
                    <CardTitle tag="h3">1. Data Retention</CardTitle>
                    <CardText>
                        OurOffice retains personal information for as long as necessary to provide services to clients in line 
                        with its data retention policies. Retention periods are regularly reviewed to ensure that personal 
                        information is not kept longer than required for the purposes outlined in this policy. Personal 
                        information may also be retained as required to comply with legal obligations, resolve disputes, 
                        or enforce agreements. Where feasible, personal information may be anonymized or pseudonymized 
                        after a defined period to minimize data retention risks. After termination of services or at the 
                        user's request, users can contact <a href="mailto:security@ouroffice.io">security@ouroffice.io</a> 
                        to request data removal or access a backup file of their data within 30 days.
                    </CardText>
                </CardBody>
            </Card>

            <Card className="mb-4">
                <CardBody>
                    <CardTitle tag="h3">2. Data Removal</CardTitle>
                    <CardText>
                        Users can request the removal of their personal information at any time by contacting 
                        <a href="mailto:security@ouroffice.io">security@ouroffice.io</a>. OurOffice will respond to 
                        these requests within 30 days. Personal information will be deleted unless it is required to 
                        meet legal obligations, for the establishment or defense of legal claims, or for compliance 
                        with other necessary requirements. Where appropriate, data may also be anonymized to preserve 
                        its utility for statistical purposes without compromising privacy.
                    </CardText>
                </CardBody>
            </Card>

            <Card className="mb-4">
                <CardBody>
                    <CardTitle tag="h3">3. Data Storage</CardTitle>
                    <CardText>
                        Personal information is stored using state-of-the-art administrative, physical, and technical 
                        measures designed to protect against unauthorized access, use, disclosure, alteration, or 
                        destruction. Encryption is used both during transmission (SSL) and at rest to ensure maximum 
                        security of sensitive data. Data access is restricted based on specific access levels and 
                        monitored through auditing measures, with penalties for unauthorized access. OurOffice also 
                        contracts third-party experts for regular independent network, system, and application 
                        vulnerability assessments to ensure security standards evolve with emerging threats. Where 
                        possible, data is stored in compliance with data localization regulations, ensuring that 
                        sensitive data is stored in its region of origin when required by law.
                    </CardText>
                </CardBody>
            </Card>
        </Container>
        </div>
       
    );
};

export default DataPolicies;
